<template>
    <footer class="ticket-footer">
        <Button
            :size="miniTicket ? 's' : 'm'"
            :theme="miniTicket ? 'yellow' : 'blue'"
            expanded
            :disabled="disableBetButton || isLoading"
            :is-loading="(!isMobile || miniTicket) && isLoading"
            :uppercase="false"
            @click="placeBet"
        >
            {{ buttonText }}
        </Button>
        <span v-if="miniTicket && isLoading" class="ticket-footer__info">Probíhá vsazení tiketu...</span>
        <span
            v-else-if="miniTicket && isInputInvalid"
            class="ticket-footer__info ticket-footer__info--invalid"
            v-html="inputErrorText"
        >
        </span>
        <span v-else class="ticket-footer__info">
            Možná výhra: <strong>{{ possibleWin }}</strong>
        </span>
    </footer>
</template>

<script lang="ts" setup>
import { computed, ComputedRef } from "vue";
import Button from "@/shared/components/atoms/Button.vue";
import { MIN_KOMBI_STAKE, MIN_STAKE, useTicketStore } from "@/ticket/stores/use-ticket-store";
import useUtils from "@/shared/composables/use-utils";
import useIsBreakpoint from "@/shared/composables/use-is-breakpoint";
import useInputValidationStore from "@/shared/composables/use-input-validation";
import { TicketType } from "@/shared/model/ticket";

const props = withDefaults(
    defineProps<{
        miniTicket?: boolean;
    }>(),
    {
        miniTicket: false,
    },
);

const emit = defineEmits(["on-place-bet"]);

const ticketStore = useTicketStore();
const { isInputInvalid } = useInputValidationStore();

const { formatPrice } = useUtils();
const { isMobile } = useIsBreakpoint();

const disableBetButton: ComputedRef<boolean> = computed(
    () => ticketStore.isErrorRaised || !ticketStore.stake || (props.miniTicket && isInputInvalid.value),
);

const buttonText: ComputedRef<string> = computed(() => {
    if (props.miniTicket) {
        return "VSADIT";
    } else {
        return `VSADIT ${formatPrice(ticketStore.stake)}`;
    }
});

const possibleWin: ComputedRef<string> = computed(() => {
    let posWin = ticketStore.possibleWin;
    // Precalculate here possible win for mini-ticket because we don't want to wait for response from build slip ep.
    // It does not count with 'bonus' but is highly unlikely that single outcome will have some.
    if (props.miniTicket && !ticketStore.possibleWin) {
        posWin = ticketStore.stake * (ticketStore.ticketOutcomes?.[0]?.prices?.[0]?.decimal || 0);
    }

    return formatPrice(posWin);
});
const isLoading: ComputedRef<boolean> = computed(() => Boolean(ticketStore.sendingInProgress));
const placeBet = () => {
    emit("on-place-bet");
    ticketStore.sendTicket();
};

const inputErrorText = computed(() => {
    if (ticketStore.ticketType === TicketType.KOMBI) {
        return `Minimální vklad je ${MIN_KOMBI_STAKE}&nbsp;Kč`;
    } else {
        return `Minimální vklad je ${MIN_STAKE}&nbsp;Kč`;
    }
});
</script>
